import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static scenarios(
    startAt = 0,
    numberToGet = 10,
    patientAge = -1,
    patientCondition = -1,
    searchTerm = -1,
    tags = -1
  ) {
    let commaDelimTags = -1;
    if (tags.length > 0) {
      commaDelimTags = tags.join(",");
    }
    return this.apiRequest(
      API_SUFFIX +
        "/api/scenarios/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        patientAge +
        "/" +
        patientCondition +
        "/" +
        searchTerm +
        "/" +
        commaDelimTags,
      {},
      "GET"
    );
  }

  static getUsersPublicScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/view-user/" + userId + "/scenarios",
      {},
      "GET"
    );
  }

  static scenario(uuidId) {
    return this.apiRequest(API_SUFFIX + "/api/scenario/" + uuidId, {}, "GET");
  }

  static myScenarios(startAt = 0, numberToGet = 10, sortBy = 'isProcessed', sortDirection = 'DESC') {
    return this.apiRequest(
      `${API_SUFFIX}/api/me/scenarios/${startAt}/${numberToGet}/${sortBy}/${sortDirection}`,
      {},
      "GET"
    );
  }

  static scenarioTags() {
    return this.apiRequest(API_SUFFIX + "/api/tags", {}, "GET");
  }

  static scenarioTagsInUse() {
    return this.apiRequest(API_SUFFIX + "/api/tagsInUse", {}, "GET");
  }

  static favouritedScenarios() {
    return this.apiRequest(
      API_SUFFIX + "/api/me/scenarios/favourites",
      {},
      "GET"
    );
  }

  static toggleFavouriteScenario(scenarioId) {
    return this.apiRequest(
      API_SUFFIX + "/api/me/scenarios/favourite/" + scenarioId,
      {},
      "POST"
    );
  }

  static changePrivacyLevel(data, scenarioId) {
    return this.apiUpload(
      API_SUFFIX + "/api/scenario/" + scenarioId + "/privacy/edit",
      data,
      "POST"
    );
  }

  static editScenario(data, scenarioUuidId) {
    return this.apiUpload(
      API_SUFFIX + "/api/scenario/" + scenarioUuidId + "/edit",
      data,
      "POST"
    );
  }

  static uploadScenario(formData) {
    return this.apiUpload(API_SUFFIX + "/api/me/scenarios/upload", formData);
  }

  static deleteScenario(scenarioId) {
    return this.apiUpload(
      API_SUFFIX + "/api/scenario/" + scenarioId + "/delete",
      {},
      "POST"
    );
  }

  static getUsersFavouritedScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/user/" + userId + "/scenarios/favourites",
      {},
      "GET"
    );
  }

  static downloadScenario(scenarioUuidId) {
    return this.apiRequest(
      API_SUFFIX + "/api/download/scenario/" + scenarioUuidId,
      {},
      "GET"
    );
  }
}
